import React from 'react';
import { Box, Container, Flex, Progress, HStack, VStack, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, SimpleGrid, Divider, CircularProgressLabel, CircularProgress, } from '@chakra-ui/react';
import Tag from '../../../../../components/content/tag';
import COLORS from '../../../../../constants/colors';
import FONTS from '../../../../../constants/fonts';
import { t } from 'i18next';
import { tKeys } from '../../../../../translations/keys';
import Text from '../../../../../components/content/text';
import Icon from '../../../../../components/content/icon';
import { useLogic } from './logic.web';
import { TaskTypeEnum } from '../../../../../enum/TaskType';
import LoadingAnimation from '../../../../../components/utility/loading';
import Avatar from '../../../../../components/content/avatar';
const TaskIcon = ({ type }) => {
    switch (type) {
        case TaskTypeEnum.Read:
            return (<Tag height={20} backgroundColor={COLORS.Govrn.PastelGreen.T100.value} color={COLORS.Govrn.PastelGreen.T500.value} font={FONTS.T1.T10Px.Medium500.value}>
          {t(tKeys.tasks.type.READ).toUpperCase()}
        </Tag>);
        case TaskTypeEnum.Vote:
            return (<Tag height={20} backgroundColor={'#E9D6F6'} color={'#AA55E3'} font={FONTS.T1.T10Px.Medium500.value}>
          {t(tKeys.tasks.type.VOTES).toUpperCase()}
        </Tag>);
        case TaskTypeEnum.Sign:
            return (<Tag height={20} backgroundColor={COLORS.Warning.T100.value} color={COLORS.Warning.T500.value} font={FONTS.T1.T10Px.Medium500.value}>
          {t(tKeys.tasks.type.SIGN).toUpperCase()}
        </Tag>);
        case TaskTypeEnum.RSVP:
            return (<Tag height={20} backgroundColor={COLORS.Govrn.Pink.T100.value} color={COLORS.Govrn.Pink.T500.value} font={FONTS.T1.T10Px.Medium500.value}>
          {t(tKeys.tasks.type.RSVP).toUpperCase()}
        </Tag>);
    }
};
const StatusIcon = ({ completed }) => {
    const color = completed ? COLORS.Govrn.PastelGreen.T500.value : 'red';
    return completed ? (<Icon name="check" width={16} height={16} color={color}/>) : (<Icon name="cross" width={16} height={16} fill={color}/>);
};
export default function EventDetailsMeetingEngagement({ event, isAdmin, }) {
    const { cardBg, borderColor, calculateCompletion, getMemberStatus, sortMembers, members, isEventEngagementLooading, } = useLogic(event.id);
    return (<Container maxW="7xl" overflow="auto">
      <Box bg={cardBg} p={6} mb={8}>
        <Flex justify="space-between" align="left" mb={6}>
          <VStack spacing={2} alignItems="flex-start">
            <Text font={FONTS.T1.T16Px.SemiBold600.value}>
              {t('event.details.meeting_engagement')}
            </Text>
            <Text font={FONTS.T1.T12Px.Regular400.value}>
              {t('event.details.meeting_engagement_description')}
            </Text>
          </VStack>
          <HStack spacing={4} bg={COLORS.BG.value} p={3} rounded="lg" divider={<Divider orientation="vertical" height="24px"/>}>
            {isEventEngagementLooading ? (<LoadingAnimation />) : (<HStack spacing={4} position="relative" maxWidth="250px" align="center">
                <CircularProgress value={calculateCompletion(members)} color={COLORS.Govrn.Blue.T500.value} size="40px" thickness="8px" trackColor={COLORS.Govrn.Blue.T100.value} capIsRound>
                  <CircularProgressLabel fontFamily={FONTS.T1.T14Px.Medium500.value.fontFamily} fontSize={FONTS.T1.T14Px.Medium500.value.fontSize} fontWeight={FONTS.T1.T14Px.Bold.value.fontWeight} color={COLORS.Govrn.Blue.T500.value}>
                    {calculateCompletion(members)}%
                  </CircularProgressLabel>
                </CircularProgress>
                <Text font={FONTS.T1.T14Px.SemiBold600.value}>
                  {t('engagement.tasksComplete')}
                </Text>
              </HStack>)}
          </HStack>
        </Flex>

        <Accordion allowMultiple>
          {sortMembers(members)?.map(member => (<AccordionItem key={member.id} border="1px" borderColor={borderColor} rounded="lg" mb={4}>
              <AccordionButton py={4}>
                <Flex flex="1" align="center" justify="space-between">
                  <HStack>
                    <Avatar width={8} height={8} name={member.name} imageSource={member.avatar} placeholderFont={FONTS.T1.T14Px.Medium500.value}/>
                    <Text font={FONTS.T1.T14Px.Medium500.value}>
                      {member.name}
                    </Text>
                  </HStack>
                  <HStack spacing={0}>
                    {!member.hasRSVP && (<HStack spacing={2}>
                        <Text font={FONTS.T1.T12Px.Regular400.value} color="red">
                          {t('engagement.notRSVPd')}
                        </Text>
                      </HStack>)}
                    {member.hasRSVP && (<Container>
                        <HStack spacing={2} alignItems="center">
                          <Progress value={getMemberStatus(member)} width="60px" height="8px" colorScheme="blue" bg={COLORS.Govrn.Blue.T100.value}/>
                          <Text font={FONTS.T1.T12Px.Regular400.value} color="gray.600">
                            {getMemberStatus(member)}%
                          </Text>
                          <AccordionIcon />
                        </HStack>
                      </Container>)}
                  </HStack>
                </Flex>
              </AccordionButton>

              {member.hasRSVP && (<AccordionPanel pb={4}>
                  <SimpleGrid columns={{ base: 1, md: 1, lg: 2 }} spacing={4}>
                    {member.tasks.map(task => (<Flex key={task.id} justify="space-between" align="center" bg={cardBg} p={3} rounded="lg" border="1px" borderColor={borderColor}>
                        <HStack spacing={3}>
                          <TaskIcon type={task.type}/>
                          <Text color="gray.600" font={FONTS.T1.T14Px.Regular400.value}>
                            {task.title}
                          </Text>
                        </HStack>
                        <StatusIcon completed={!!task.completedOn}/>
                      </Flex>))}
                  </SimpleGrid>
                </AccordionPanel>)}
            </AccordionItem>))}
        </Accordion>
      </Box>
    </Container>);
}
